(() => {
  if (window.acS10PurchasePreviewLoaded) return;
  window.acS10PurchasePreviewLoaded = true;
  const hoverArrows = new WeakSet();
  const desktopHover = matchMedia('(min-width: 1000px) and (hover: hover) and (pointer: fine)');
  const bind = () => {
    document.querySelectorAll('.ac-s10-purchase details[is="accordion-disclosure"] > summary .circle-chevron').forEach(arrow => {
      if (hoverArrows.has(arrow)) return;
      hoverArrows.add(arrow);
      arrow.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && desktopHover.matches) {
          arrow.closest('details').open = true;
        }
      });
    });
    const teaser = document.querySelector('.kl-teaser-SS23ww [role="button"]');
    document.querySelectorAll('[data-ac-s10-offer]').forEach(button => { button.hidden = !teaser; });
  };
  document.addEventListener('click', event => {
    const stepper = event.target.closest('[data-ac-fbt-step]');
    if (stepper) {
      const form = stepper.closest('form');
      const input = form.elements.quantity;
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : Infinity;
      input.value = Math.max(min, Math.min(max, (Number(input.value) || min) + Number(stepper.dataset.acFbtStep) * (Number(input.step) || 1)));
      syncQuantity(form);
    }
    if (event.target.closest('[data-ac-s10-offer]')) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'SS23ww']);
    }
  });
  function syncQuantity(form) {
    const input = form.elements.quantity;
    form.querySelector('[data-ac-fbt-step="-1"]').disabled = Number(input.value) <= Number(input.min || 1);
    form.querySelector('[data-ac-fbt-step="1"]').disabled = !!input.max && Number(input.value) >= Number(input.max);
  }
  document.addEventListener('change', event => {
    const form = event.target.closest('.ac-s10-fbt__form');
    if (!form) return;
    if (event.target.matches('[data-ac-fbt-variant]')) {
      const option = event.target.selectedOptions[0];
      form.querySelector('[data-ac-fbt-price]').textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      form.querySelector('[type="submit"]').disabled = !available;
      const status = form.querySelector('[data-ac-fbt-status]');
      status.textContent = 'Sold out';
      status.hidden = available;
      const input = form.elements.quantity;
      input.min = option.dataset.min || '1';
      input.step = option.dataset.step || '1';
      input.max = form.closest('[data-ac-fbt-warranty]') ? '1' : option.dataset.max || '';
      input.value = input.min;
    }
    syncQuantity(form);
  });
  document.addEventListener('cart:error', event => {
    if (!event.target.matches('.ac-s10-fbt__form')) return;
    const status = event.target.querySelector('[data-ac-fbt-status]');
    status.textContent = event.detail.error;
    status.hidden = false;
  });
  document.addEventListener('variant:add', event => {
    if (!event.target.matches('.ac-s10-fbt__form')) return;
    const status = event.target.querySelector('[data-ac-fbt-status]');
    status.textContent = 'Added to cart';
    status.hidden = false;
  });
  let scheduled = false;
  new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; bind(); });
  }).observe(document.body, {childList: true, subtree: true});
  bind();
})();
